type TeamBadgeProps = {
  shortName: string;
  color: string;
  size?: "sm" | "md" | "lg";
};

const SIZES: Record<string, string> = {
  sm: "w-9 h-9 text-[11px]",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-lg",
};

export default function TeamBadge({ shortName, color, size = "md" }: TeamBadgeProps) {
  const label = shortName.length > 2 ? shortName.slice(0, 2) : shortName;
  return (
    <span
      className={`${SIZES[size]} rounded-full flex items-center justify-center font-heading font-semibold text-white shrink-0 ring-2 ring-white/15`}
      style={{ backgroundColor: color }}
      title={shortName}
    >
      {label}
    </span>
  );
}